import React from "react";
import { TABLE_PAD_HEIGHT_OPTIONS, TABLE_PAD_STYLE_OPTIONS, TABLE_PAD_COVER_OPTIONS } from "../constant";
import styles from "./ORStretcherPads.module.scss";
import { SubmissionSuccess } from "./SubmissionSuccess";
import { TablePadCard } from "./TablePadCard";
import { SelectField } from "../SelectField";
import { FormActions } from "../FormActions";

export const TablePadFinalView = ({ selectedTablePad, formData, setFormData, errors, submitting, submitted, onSubmit }) => {
  return (
    <div className={styles.section}>
      <div className={styles.selectedCardWrap}>
        <TablePadCard modelName={selectedTablePad.modelName} image={selectedTablePad.image} selectable={false} />
      </div>

      <SelectField
        id="pad-height"
        label="Select Pad Height"
        required
        value={formData.padHeight}
        onChange={(v) => setFormData((prev) => ({ ...prev, padHeight: v }))}
        options={TABLE_PAD_HEIGHT_OPTIONS}
        placeholder="Select pad height"
        error={errors.padHeight}
      />

      <SelectField
        id="pad-style"
        label="Select Style"
        required
        value={formData.style}
        onChange={(v) => setFormData((prev) => ({ ...prev, style: v }))}
        options={TABLE_PAD_STYLE_OPTIONS}
        placeholder="Select style"
        error={errors.style}
      />

      <SelectField
        id="pad-cover"
        label="Cover Options"
        required
        value={formData.coverOptions}
        onChange={(v) => setFormData((prev) => ({ ...prev, coverOptions: v }))}
        options={TABLE_PAD_COVER_OPTIONS}
        placeholder="Select cover option"
        error={errors.coverOptions}
      />

      {submitted && (
        <SubmissionSuccess
          message="Your request for the O.R. Table Pad has been submitted. A Medline respresentative will contact you shortly"
        />
      )}

      <FormActions onClick={onSubmit} loading={submitting} label="Submit" />
    </div>
  );
};
